import React, { Fragment, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import { SITENAMEALIAS, LOGO, ASSETS } from "../utils/init";
import Moment from "react-moment";
import { Link, withRouter } from "react-router-dom";
import {
  showToast,
  showHttpError,
  formatAmount,
  currentPageAccess,
} from "../utils/library";
import BtcLogo from "../assets/images/currency/BTC.svg";
import EthLogo from "../assets/images/currency/ETH.svg";
import LtcLogo from "../assets/images/currency/LTC.svg";
import btcLogo from "../assets/images/currency/BTC.svg";
import BchLogo from "../assets/images/currency/BCH.svg";
import axios from "axios";

class Session extends React.Component {
  constructor(props) {
    super(props);
    // this.paybitoLogin = this.handleAuthorChange.bind(this)
    this.state = {
      showLoader: true,
      userId: null,
      uuid: null,
      token: null,
    };
  }

  /* Method defination for get user exchange details */

  getUserExchangeDetails = async () => {
    try {
      // Save token to localStorage
      localStorage.setItem("paybito_access_token", this.state.token);

      // Prepare request payload
      const payload = {
        uuid: this.state.uuid,
        userId: this.state.userId,
      };

      // Make POST request using axios
      const response = await axios.post(
        "https://accounts.paybito.com/api/user/GetUserDetails",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "BEARER " + this.state.token,
          },
        }
      );

      const paybitouserDetails = response.data.userResult;
      console.log("paybito user details", paybitouserDetails);
      if (response.data.error.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
      } else {
        // Save user details in localStorage
        localStorage.setItem(
          SITENAMEALIAS + "_paybito_id",
          paybitouserDetails.userId
        );
        localStorage.setItem(
          SITENAMEALIAS + "_paybito_uuid",
          paybitouserDetails.uuid
        );
        localStorage.setItem(
          SITENAMEALIAS + "_paybito_country",
          paybitouserDetails.country
        );

        this.props.history.push("/wallet");
      }
    } catch (error) {
      console.error("Error fetching Exchange user details:", error);
      showHttpError(error);
      // Optionally show an error toast or message to the user
    }
  };

  componentDidMount() {
    const queryParams = new URLSearchParams(this.props.location.search);
    const objParam = queryParams.get("obj");
    if (!objParam) {
      showToast("error", "Failed to connect with your exchange");
      return;
    }
    //console.log('Object Param:', objParam);
    const decodedData = JSON.parse(atob(objParam));
    //console.log(decodedData);
    this.setState(
      {
        userId: decodedData.userId,
        uuid: decodedData.uuid,
        token: decodedData.token,
      },
      () => {
        this.getUserExchangeDetails();
      }
    );
  }

  render() {
    return (
      <Fragment>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            <div className="row ml-0 pr-4 pl-4 mt-4">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card"></div>
              </div>
            </div>

            <div className="row ml-0 pr-4 pl-4"></div>

            <Footer />
          </div>

          <Loader show={this.state.showLoader} />
        </div>
      </Fragment>
    );
  }
}

export default withRouter(Session);
